export default {
  path: '/logistics',
  name: 'Logistics',
  meta: {
    title: '物流',
    showTabBar: true
  },
  redirect: {
    name: 'LogisticsList'
  },
  component: () => import('@/views/layout/HomeLayout'),
  children: [
    {
      path: 'logistics-list',
      name: 'LogisticsList',
      meta: {
        title: '物流管理',
        showTabBar: true
      },
      component: () => import('@/views/Logistics')
    }
  ]
}

